import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sqg-filesNavigation" }
const _hoisted_2 = { class: "sqg-filesNavigation__line" }
const _hoisted_3 = { class: "sqg-filesNavigation__line" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1)
const _hoisted_5 = { class: "sqg-filesNavigation__line" }
const _hoisted_6 = { class: "sqg-filesNavigation__check" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" éléments sélectionnés ")
const _hoisted_8 = {
  key: 0,
  class: "sqg-filesNavigation__actions"
}
const _hoisted_9 = { style: {"position":"relative","width":"100%"} }
const _hoisted_10 = {
  key: 0,
  class: "sqg-filesNavigation__results"
}
const _hoisted_11 = {
  key: 0,
  class: "sqg-filesNavigation__noResults"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Aucun fichier ...")
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "sqg-filesNavigation__results"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_CardButton = _resolveComponent("CardButton")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_TableItemSkeleton = _resolveComponent("TableItemSkeleton")!
  const _component_TableItem = _resolveComponent("TableItem")!
  const _component_UploadFile = _resolveComponent("UploadFile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      icone: "fas fa-file",
      title: "Listes des fichiers",
      displayCurrentFolder: ""
    }),
    _createElementVNode("div", {
      class: _normalizeClass(['sqg-filesNavigation__board', {'-loading': _ctx.folderLoader}])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_CardButton, {
          width: "25",
          height: "96",
          class: "sqg-filesNavigation clickable",
          icon: "fas fa-file-upload",
          text: "Charger un fichier",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isUploadFileOpen = true))
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Card, {
          width: "100",
          height: "40",
          class: "sqg-filesNavigation__search"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createVNode(_component_Input, {
              type: "text",
              placeholder: "Rechercher un fichier ...",
              modelValue: _ctx.searchTerm,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTerm) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Checkbox, {
            id: "selectAll",
            checked: _ctx.filesCheck.length === _ctx.filesToDisplay.length,
            onOnChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleFilesCheck()))
          }, null, 8, ["checked"]),
          _createElementVNode("strong", null, "( " + _toDisplayString(_ctx.filesCheck.length) + " )", 1),
          _hoisted_7
        ]),
        (_ctx.filesCheck.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_ctx.isActionAvailable(_ctx.filesCheck, 'download'))
                ? (_openBlock(), _createBlock(_component_CardButton, {
                    key: 0,
                    small: "",
                    icon: "fas fa-file-download",
                    text: "Télécharger",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openAllFiles()))
                  }))
                : _createCommentVNode("", true),
              (_ctx.isActionAvailable(_ctx.filesCheck, 'delete'))
                ? (_openBlock(), _createBlock(_component_CardButton, {
                    key: 1,
                    small: "",
                    icon: "fas fa-trash",
                    text: "Supprimer",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteAll()))
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.folderLoader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (file, index) => {
                return _createVNode(_component_TableItemSkeleton, {
                  key: index,
                  fields: [{}, {}],
                  actions: [{}, {}]
                })
              }), 64))
            ]))
          : _createCommentVNode("", true),
        (!_ctx.folderLoader)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.filesToDisplay.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filesToDisplay, (file) => {
                      return (_openBlock(), _createBlock(_component_TableItem, {
                        key: file.id,
                        item: file,
                        isCheck: _ctx.arrayHasBasedOnId(_ctx.filesCheck, file),
                        onDelete: ($event: any) => (_ctx.deleteFile(file.id)),
                        onDownload: ($event: any) => (_ctx.openFile(file.id)),
                        onCheck: _cache[5] || (_cache[5] = ($event: any) => (_ctx.arrayToggleBaseOnId(_ctx.filesCheck, $event)))
                      }, null, 8, ["item", "isCheck", "onDelete", "onDownload"]))
                    }), 128))
                  ]))
            ], 64))
          : _createCommentVNode("", true)
      ])
    ], 2),
    (_ctx.isUploadFileOpen)
      ? (_openBlock(), _createBlock(_component_UploadFile, {
          key: 0,
          folderIds: [_ctx.currentFolder.id],
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isUploadFileOpen = false)),
          onUploadFile: _ctx.uploadFileSuccess
        }, null, 8, ["folderIds", "onUploadFile"]))
      : _createCommentVNode("", true)
  ]))
}